<panel width="700" [refresh]="dataProvider?.refreshService">
    <menu always-visible>
        <menuitem *requiredCredential="credentialTypeEnum.CreateProductPlanManually" (click)="createProductPlan()" icon="plus">{{ 'company.product-plans.create' | translate }}</menuitem>
        <menuitem *requiredCredential="credentialTypeEnum.EditCompanyAccountingSettings" (click)="toggleHandlingFees()" icon="chart-pie-simple-circle-dollar">{{ (noHandlingFees ? 'company.accounting.include-invoice-fees' : 'company.accounting.exempt-from-invoice-fees') | translate }}</menuitem>
        <menuitem *requiredCredential="credentialTypeEnum.EditSettlements" (click)="createSettlement()" icon="balance-scale">{{ 'company.create-settlement' | translate }}</menuitem>
        <menuitem *requiredCredential="credentialTypeEnum.EditAccountingPlan" (click)="terminateAllproductPlans()" [disabled]="terminatableProductPlans.length == 0" icon="door-open">{{ 'company.product-plans.terminate-all' | translate }}</menuitem>
        <menuitem *requiredCredential="credentialTypeEnum.ProductPlanCompanyTransfer" (click)="createTransfer()" icon="exchange">{{ 'company.create-transfer' | translate }}</menuitem>
        <menuitem [disabled]="plansAvailableForStandoutSyncronization.length == 0" (click)="syncPlansToStandoutCrm()" icon="refresh">{{ 'company.syncronize-plans-to-standout-crm' | translate }}</menuitem>
    </menu>

    <h1>{{ 'company.products' | translate }}</h1>

    <list-view [selectable]="false" emptyLabel="">
        @if (noHandlingFees) {
            <list-item warning [clickable]="false" statusIcon="hand-holding-dollar">
                {{ 'company.accounting.is-exempt-from-invoice-fees' | translate }}
            </list-item>
        }
    </list-view>

    @if (!loading) {
        <company-products-list #productPlanList [productPlans]="allProductPlans" [(selectedProductPlan)]="selectedProductPlan" [legalCases]="companyLegalCases" [settlement]="settlementInfo?.activeSettlement" [showCurrentAccountingPlanData]="true" />
    }
    @if (loading || !productPlanList?.ready) {
        <skeletons [customSkeletons]="[['1em', '100%'], ['1em', '100%'], ['1em', '100%']]" />
    }
</panel>

@if (selectedProductPlan && !loading && !selectedProductPlan.$deleted) {
    <product-plan [productPlan]="selectedProductPlan" [accountingPlan]="selectedAccountingPlan" />
    <company-products-ledger-posts [productPlans]="[selectedProductPlan]" [displayProductName]="false" [accountingPlan]="selectedAccountingPlan" />
}

@if (!selectedProductPlan && allProductPlans && allProductPlans.length) {
    <company-products-ledger-posts [productPlans]="allProductPlans" [displayProductName]="true" splitByKey="year" [showClosedPosts]="false" />
}
